import { useEffect, useMemo, useRef, useState } from "react"

const PX_PER_CHAR = 7

const useMaxLength = (pxPerChar = PX_PER_CHAR) => {
  const [width, setWidth] = useState(0)
  const ref = useRef(null)

  useEffect(() => {
    const element = ref.current
    if (!element) return undefined

    const updateWidth = () => setWidth(element.offsetWidth)
    updateWidth()

    if (typeof ResizeObserver !== 'undefined') {
      const observer = new ResizeObserver(updateWidth)
      observer.observe(element)

      return () => observer.disconnect()
    }

    window.addEventListener('resize', updateWidth)
    return () => window.removeEventListener('resize', updateWidth)
  }, [ref])

  const maxLength = useMemo(() => Math.floor(width / pxPerChar), [width, pxPerChar])
  return { maxLength, ref }
}

export default useMaxLength
